<script>
import { user as columns} from "../../tables"

export default {
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      loading: false,
      expand: false,
      visible: false,
      visibleUnblock: false,
      processing: false,
      user: '',
      hash: '',
      email: '',
      username: '',
      generatedPassword: '',
      items: {},
      filters: {
        q: null,
        page: 1,
        per_page: 10,
      },
      loadingDownload: false,
    }
  },
  computed: {
    pageSize() {
      return parseInt(this.items.per_page)
    },
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime()
      })

      return this.routeUri('hyperion.user.export') + '?' + this.$qs.stringify(params)
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1
      }
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.user'), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    resetPassword(hash, user, email){
      this.visible = true
      this.user = user
      this.hash = hash
      this.email = email
      this.generatedPassword = this.generatePassword()
    },
    unblockUser(record){
      this.visibleUnblock = true
      this.user = record.name
      this.hash = record.hash
      this.email = record.email
      this.username = record.username
    },
    close(){
      this.visible = false
      this.visibleUnblock = false
      this.user = ''
      this.hash = ''
      this.email = ''

      setTimeout(() => location.reload(), 2000)
    },
    handleResetPassword(){
      this.processing = true
      let promise

      promise = this.$http.put(this.routeUri('hyperion.user.reset_password', { user_hash: this.hash }), {
        password: this.generatedPassword
      })

      promise.then((response) => this.handleSuccessResponse(response.data))
        .catch((error) => this.handleResponseError(error.response.data.data))
        .finally(() => this.processing = false)
    },
    handleUnblockUser(){
      this.processing = true
      let promise

      promise = this.$http.put(this.routeUri('hyperion.user.update', { user_hash: this.hash }), {
        action: 'unblock',
        name: this.user,
        email: this.email,
        username: this.username
      })

      promise.then((response) => this.handleSuccessResponse(response.data))
        .catch((error) => this.handleResponseError(error.response.data.data))
        .finally(() => this.processing = false)
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: 'Saved!',
        description: 'Data has been successfully saved!'
      })

      this.close()
    },
    handleResponseError(data) {
      this.form.setFields(_.mapValues(data, function (item, key) {
        return {
          errors: item.map(function (val) {
            return {
              field: key,
              message: val
            }
          })
        }
      }))

      this.$notification.error({
        message: "Failed to validate data",
        description: "We are unable to validate your request."
      })
    },
    generatePassword(){
      let length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()",
        retVal = ""

      // Ensure at least one uppercase, one lowercase, one number, and one symbol
      retVal += "ABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(Math.random() * 26))
      retVal += "abcdefghijklmnopqrstuvwxyz".charAt(Math.floor(Math.random() * 26))
      retVal += "0123456789".charAt(Math.floor(Math.random() * 10))
      retVal += "!@#$%^&*()".charAt(Math.floor(Math.random() * 10))

      for (let i = 4, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }

      // Shuffle the string to ensure randomness
      retVal = retVal.split('').sort(() => 0.5 - Math.random()).join('')
      return retVal
    },
    deleteUser(hash){
      this.$confirm({
        title: 'Do you want to delete this user?',
        content: 'This action cannot be undone.',
        onOk: () => {
          this.$http.delete(this.routeUri('hyperion.user.destroy', { user_hash: hash }))
            .then((response) => this.handleSuccessResponse(response.data))
            .catch((error) => this.handleErrorResponse(error.response.data))
            .finally(() => {})
        },
        onCancel() {},
      })
    },
    handleDownload(e) {
      console.log('handleDownload', this.exportUri)
      window.open(this.exportUri, '_blank')
    },
    handleSuccessResponseDownload(data) {
      this.$notification.success({
        message: 'Proccess!',
        description: 'Data has been processed!'
      })
    },
    handleResponseErrorDownload(data) {
      this.$notification.error({
        message: "Failed to export data",
        description: data.message
      })
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>
          <a-dropdown>
            <a-menu slot="overlay" @click="handleDownload">
              <a-menu-item key="xlsx">
                <a-icon type="file-excel" theme="twoTone" two-tone-color="#52c41a"/> XLSX
              </a-menu-item>
            </a-menu>
            <a-button class="ml-2" type="dashed" shape="circle" icon="cloud-download" :style="{ display: expand ? 'inline-block' : 'none'}" :loading="loadingDownload"/>
          </a-dropdown>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table
        :columns="columns"
        :dataSource="items.data"
        rowKey="hash"
        :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
        @change="tableChanged"
      >
        <div slot="name" slot-scope="record">
          <a-button size="small" type="link" icon="contacts"/>
          {{ record.name }}
        </div>

        <div slot="branch" slot-scope="record">
          {{ record.branch ? record.branch.name : '' }}
        </div>

        <div slot="branch_code" slot-scope="record">
          {{ record.branch ? record.branch.id : '' }}
        </div>

        <div slot="phone_number" slot-scope="record">
          <a-button size="small" type="link" icon="phone" :href="'tel:' + record.phone_number"/>
          {{ record.phone_number }}
        </div>

        <div slot="username" slot-scope="record">
          {{ record.username }}
        </div>

        <div slot="email" slot-scope="record">
          <a-button size="small" type="link" :href="'mailto:' + record.email" icon="mail"/>
          {{ record.email }}
        </div>

        <div slot="role" slot-scope="record">
          {{ record.role ? record.role : '' }}
        </div>

        <div slot="status" slot-scope="record">
          <a-tag style="cursor:pointer; margin-right: 0;" color="#87d068" v-if="record.status == 'active'">Active</a-tag>
          <a-tag style="cursor:pointer; margin-right: 0;" color="#f1c232" v-else-if="record.status == 'inactive'">Inactive</a-tag>
          <a-tag style="cursor:pointer; margin-right: 0;" color="#f44336" v-else>Blocked</a-tag>
        </div>

        <p slot="updatedAt" slot-scope="updated_at" class="text-sm">
          <a-tooltip :title="moment(updated_at).format('YYYY-MM-DD HH:mm:ss')">
            {{ moment(updated_at).fromNow() }}
          </a-tooltip>
        </p>

        <div slot="action" slot-scope="record" class="text-center">
          <a-tooltip title="Ubah Password">
            <a-button size="small" type="danger" icon="redo" @click="resetPassword(record.hash, record.name, record.email)"/>
          </a-tooltip>

          <a-tooltip title="Edit User">
            <a-button size="small" type="primary" icon="edit" :href="routeUri('hyperion.user.edit', { user_hash: record.hash })"/>
          </a-tooltip>

          <a-tooltip title="Delete User">
            <a-button size="small" type="danger" icon="delete" @click="deleteUser(record.hash)"/>
          </a-tooltip>

          <a-tooltip title="Buka Blokir User" v-if="record.status == 'blocked'">
            <a-button size="small" type="dashed" icon="rollback" @click="unblockUser(record)"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>

    <a-modal
        :visible="visible"
        :destroyOnClose="true"
        :footer="null"
        :closable="false">

        <a-result status="warning" :title="'Apakah Anda yakin akan mengubah password user: ' + user">
          <a-input placeholder="Password" type="text" v-model="generatedPassword"/>
          <br>
            <template #extra>
                <a-button type="primary" @click="handleResetPassword" :loading="processing" :disabled="processing">
                    Reset
                </a-button>
                <a-button @click="close" :disabled="processing">
                    Tutup
                </a-button>
            </template>
        </a-result>
    </a-modal>

    <a-modal
        :visible="visibleUnblock"
        :destroyOnClose="true"
        :footer="null"
        :closable="false">

        <a-result status="warning" :title="'Apakah Anda yakin akan membuka blokir user: ' + user">
            <template #extra>
                <a-button type="primary" @click="handleUnblockUser" :loading="processing" :disabled="processing">
                    Buka Blokir
                </a-button>
                <a-button @click="close" :disabled="processing">
                    Tutup
                </a-button>
            </template>
        </a-result>
    </a-modal>

  </a-card>
</template>
